import styled from "../../Themes";

export const AlertSpan = styled<any>(`span`)`
  color: ${({ theme }) => theme.color.font_bold[2]};
  line-height: 24px;
`;
